import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/driver/")({
  component: lazyRouteComponent(() => import("./-pages/driver.index")),
  head: () => ({
    meta: [
      { title: "Driver · Lecmo" },
      { name: "robots", content: "noindex" },
      { name: "viewport", content: "width=device-width, initial-scale=1, maximum-scale=1" },
    ],
  }),
});
